import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M12 2l3 5h6l-3 5l3 5h-6l-3 5l-3 -5h-6l3 -5l-3 -5h6l3 -5","key":"svg-0"}]]

const IconJewishStar = createReactComponent('outline', 'jewish-star', 'JewishStar', __iconNode);

export default IconJewishStar;